/**
 * Animated loading spinner with optional label text.
 * Reusable across all pages and components for loading states.
 */

interface LoadingSpinnerProps {
  /** Optional text to display below the spinner. */
  label?: string;
  /** Size variant. */
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-3',
};

export default function LoadingSpinner({ label, size = 'md' }: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-8">
      <div
        className={`${sizeClasses[size]} animate-spin rounded-full border-indigo-600 border-t-transparent`}
      />
      {label && <p className="text-sm text-gray-500">{label}</p>}
    </div>
  );
}
